import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { withoutBuyerModules } from "../../../../common/subscription/withoutBuyerModules";

export const useNamesSourcingViewerAsMember = (): boolean =>
  withoutBuyerModules(useLoggedInWithOrgContextState().selectedOrg.subscription);
